var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"克拉玛依缴费专用通道","visible":_vm.dialogVisible,"close-on-press-escape":true,"close-on-click-modal":true,"width":"33%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"block"},[_c('span',[_vm._v("请扫描二维码并按照提示完成缴费操作")]),_c('el-image',{attrs:{"src":_vm.ewm}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }